import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SelectContextComponent } from '../select-context/select-context.component';
import { SiteContextType } from '@spartacus/storefront';

@Component({
  selector: 'language',
  standalone: true,
  imports: [CommonModule, SelectContextComponent],
  templateUrl: './language.component.html',
  styleUrl: './language.component.scss',
})
export class LanguageComponent {
  SiteContextType = SiteContextType;
}
